import React from "react";
import { Box, Stack, Text } from "@mantine/core";
import type { EventFlag } from "../components/Views/EventBlock";
import blockStyles from "../components/Views/EventBlock.module.css";
import styles from "./AppointmentDrawer.module.css";

/**
 * "Need to know" (design handoff): always expanded, no section icon, one row
 * per active flag with its icon chip, label and detail. Renders nothing when
 * there are no flags. Shared by the drawer and the mobile detail sheet.
 */
export default function NeedToKnow({ flags }: { flags: EventFlag[] }) {
  if (!flags.length) return null;
  return (
    <Box className={styles.needToKnow} data-testid="need-to-know">
      <Text className={styles.sectionLabel}>Need to know</Text>
      <Stack gap={8}>
        {flags.map(({ key, label, detail, Icon, tone }) => (
          <Box key={key} className={styles.flagRow}>
            <Box
              component="span"
              className={blockStyles.flag}
              data-tone={tone}
              aria-hidden
            >
              <Icon size={13} />
            </Box>
            <Box>
              <Text className={styles.flagLabel}>{label}</Text>
              {detail && <Text className={styles.flagDetail}>{detail}</Text>}
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
